<template>
  <section>
    <b-tabs>
      <b-tab-item label="ผู้ใช้งาน">
        <button class="button is-primary" @click="createUser">สร้าง</button>
        <button
          class="button is-danger"
          @click="deleteUser"
          :disabled="!checkedRows.length"
        >
          ลบ
        </button>
        <b-table
          :data="users"
          :selected.sync="selected"
          :checked-rows.sync="checkedRows"
          focusable
          checkable
          @select="editUser"
        >
          <template slot-scope="props">
            <!-- <b-table-column field="id" label="id">
              {{ props.row.id }}
            </b-table-column> -->
            <b-table-column field="name" label="ชื่อ-สกุล">
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="email" label="อีเมล์">
              {{ props.row.email }}
            </b-table-column>

            <b-table-column field="company" label="บริษัทประกันภัย">
              <b-icon
                icon="alert"
                size="is-small"
                type="is-danger"
                v-if="!props.row.company.active"
              ></b-icon>
              {{ props.row.company.name }}
            </b-table-column>

            <b-table-column field="createdAt" label="วันที่" centered>
              <span class="tag is-success">
                {{ props.row.createdAt.toDate() | moment("LLL") }}
              </span>
            </b-table-column>
          </template>
        </b-table>
        <b-modal
          :active.sync="isUserModalActive"
          :width="640"
          scroll="keep"
          @close="deselect"
        >
          <div class="card">
            <div class="card-content">
              <b-field label="ชื่อ-นามสกุล">
                <b-input v-model="user.name"></b-input>
              </b-field>

              <b-field label="อีเมล์">
                <b-input
                  type="email"
                  v-model="user.email"
                  :disabled="user.id"
                ></b-input>
              </b-field>

              <b-field label="พาสเวิร์ด">
                <b-input type="password" v-model="user.password"></b-input>
              </b-field>

              <b-field label="CC อีเมล์ 1">
                <b-input type="email" v-model="user.ccEmail1"></b-input>
              </b-field>

              <b-field label="CC อีเมล์ 2">
                <b-input type="email" v-model="user.ccEmail2"></b-input>
              </b-field>

              <b-field label="บริษัทประกันภัย">
                <b-select
                  v-model="user.company"
                  placeholder="เลือก บริษัทประกันภัย"
                >
                  <option
                    v-for="option in companies"
                    :value="option"
                    :key="option.id"
                    >{{ option.name }}</option
                  >
                </b-select>
              </b-field>

              <div class="box">
                <nav class="level">
                  <div class="level-left">
                    <div class="level-item">
                      <h4>กรมธรรม์</h4>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <button class="button is-primary" @click="addPolicy">
                        เพิ่ม
                      </button>
                    </div>
                  </div>
                </nav>
                <div
                  v-for="(policy, idx) in user.policies"
                  :key="idx"
                  class="notification"
                >
                  <button
                    class="delete"
                    @click="deletePolicy(policy.no)"
                  ></button>
                  <b-field label="เลข กรมธรรม์.">
                    <b-input type="text" v-model="policy.no"></b-input>
                  </b-field>
                  <b-field label="บันทึกข้อความ">
                    <b-input type="text" v-model="policy.memo"></b-input>
                  </b-field>
                  <b-field label="จำนวน กรมธรรม์">
                    <b-input
                      type="number"
                      step="1"
                      v-model="policy.balance"
                      required
                    ></b-input>
                  </b-field>
                </div>
              </div>

              <button class="button is-primary" @click="saveUser">
                บันทึก
              </button>
            </div>
          </div>
        </b-modal>
      </b-tab-item>

      <b-tab-item label="บริษัท">
        <button class="button is-primary" @click="createCompany">สร้าง</button>
        <button
          class="button is-danger"
          @click="deleteCompany"
          :disabled="!companyCheckedRows.length"
        >
          ลบ
        </button>

        <b-table
          :data="companies"
          :selected.sync="selected"
          :checked-rows.sync="companyCheckedRows"
          checkable
          focusable
          @select="editCompany"
        >
          <template slot-scope="props">
            <b-table-column field="name" label="ชื่อ">
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="email" label="อีเมล์">
              {{ props.row.email }}
            </b-table-column>
          </template>
        </b-table>
        <b-modal
          :active.sync="isCompanyModalActive"
          :width="640"
          scroll="keep"
          @close="deselect"
        >
          <div class="card">
            <div class="card-content">
              <b-field label="Name">
                <b-input v-model="company.name"></b-input>
              </b-field>

              <b-field label="Email">
                <b-input type="email" v-model="company.email"></b-input>
              </b-field>

              <button class="button is-primary" @click="saveCompany">
                บันทึก
              </button>
            </div>
          </div>
        </b-modal>
      </b-tab-item>
    </b-tabs>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import { db } from "@/main";

export default {
  name: "setting",
  data() {
    return {
      user: { policies: [] },
      users: [],
      companies: [],
      company: {},
      selected: null,
      checkedRows: [],
      companyCheckedRows: [],
      isUserModalActive: false,
      isCompanyModalActive: false,
      isFullPage: true,
      isLoading: false
    };
  },
  firestore() {
    return {
      users: db
        .collection("users")
        .where("active", "==", true)
        .orderBy("createdAt"),
      companies: db
        .collection("companies")
        .where("active", "==", true)
        .orderBy("name", "asc")
    };
  },
  methods: {
    editUser(row) {
      this.user = { ...row };
      this.user.id = row.id; // why id not extract ?
      this.isUserModalActive = true;
    },
    editCompany(row) {
      this.company = { ...row };
      this.company.id = row.id;
      this.isCompanyModalActive = true;
    },
    deselect() {
      this.selected = null;
    },
    createUser() {
      this.user = { company: {}, policies: [] };
      this.isUserModalActive = true;
    },
    createCompany() {
      this.company = {};
      this.isCompanyModalActive = true;
    },
    addPolicy() {
      this.user.policies.push({
        no: "",
        balance: 0,
        memo: ""
      });
    },
    deletePolicy(no) {
      let set = [];
      this.user.policies.forEach(x => {
        if (x.no != no) set.push(x);
      });
      this.user.policies = set;
    },
    saveUser() {
      let companyId = this.user.company.id;
      if (this.user.id) {
        // update mode
        let uid = this.user.id;
        let updateData = this.user;
        delete updateData.id;
        updateData.policies = this.user.policies.map(p => ({
          balance: parseInt(p.balance),
          no: p.no,
          memo: p.memo
        }));
        updateData.company = db.collection("companies").doc(companyId);
        return db
          .collection("users")
          .doc(uid)
          .update(updateData)
          .then(() => {
            this.user = { policies: [] };
            this.isUserModalActive = false;
          });
      } else {
        this.user.createdAt = new Date();
        let newUser = Object.assign({ active: true }, this.user);
        newUser.company = db.collection("companies").doc(companyId);
        return db
          .collection("newUsers")
          .add(newUser)
          .then(() => {
            this.user = { policies: [] };
            this.isUserModalActive = false;
          });
      }
    },
    deleteUser() {
      this.isLoading = true;
      let batch = db.batch();
      this.checkedRows.forEach(user => {
        let userRef = db.collection("users").doc(user.id);
        batch.update(userRef, { active: false });
      });
      batch.commit().then(() => {
        this.isLoading = false;
      });
    },
    saveCompany() {
      return Promise.resolve()
        .then(() => {
          if (!this.company.active) {
            return db
              .collection("companies")
              .add(Object.assign({ active: true }, this.company));
          } else {
            return db
              .collection("companies")
              .doc(this.company.id)
              .update({
                name: this.company.name,
                email: this.company.email
              });
          }
        })
        .then(() => {
          this.company = {};
          this.isCompanyModalActive = false;
        });
    },
    deleteCompany() {
      this.isLoading = true;
      let batch = db.batch();
      this.companyCheckedRows.forEach(company => {
        let companyRef = db.collection("companies").doc(company.id);
        batch.update(companyRef, { active: false });
      });
      batch.commit().then(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>
